import styled from 'styled-components';
import { Loader as LibLoader } from '@elfsight/widget-ui';

export function renderLoader({ color, size = 40 }) {
  return function Loader() {
    return (
      <LoaderContainer>
        <LibLoader color={color} size={size} />
      </LoaderContainer>
    );
  };
}

const LoaderContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
